import * as React from "react"
import { DateRangePicker } from 'rsuite'
import { DatePickerSeeker } from "ui-seeker/core"


const { beforeToday } = DateRangePicker

export default function CustomDatePicker({ ...props }) {
	const myProps = {
		label: '',
		className: 'mt-0',
		disabledDate: d => beforeToday()(d),
		...props
	}

    return <DatePickerSeeker {...myProps} />
}